export const UPLAOD_DEED_SUCCESS = "UPLAOD_DEED_SUCCESS";
export const UPLAOD_DEED_FAIL = "UPLAOD_DEED_FAIL";

export const SEARCH_DEED_DETAIL_SUCCESS = "SEARCH_DEED_DETAIL_SUCCESS";
export const SEARCH_DEED_DETAIL_FAIL = "SEARCH_DEED_DETAIL_FAIL";

export const FETCH_DEED_RECORDS_SUCCESS = "FETCH_DEED_RECORDS_SUCCESS";
export const FETCH_DEED_RECORDS_FAIL = "FETCH_DEED_RECORDS_FAIL";

export const FETCH_DEED_ADDRESS_SUCCESS = "FETCH_DEED_ADDRESS_SUCCESS";
export const FETCH_DEED_ADDRESS_FAIL = "FETCH_DEED_ADDRESS_FAIL";

export const RESET_DEED_REDUCER = "RESET_DEED_REDUCER";
